import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeValidityRequest from "./chargeValidityRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargesRequest {
  /**
   * Vehicle registration plates.
   */
  @observable
  licensePlates!: string[];

  /**
   * Country ID.
   */
  @observable
  countryId!: string;

  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => ChargeValidityRequest)
  validity!: ChargeValidityRequest;
}
